package com.eladfinish.bible.contest.utils

import com.eladfinish.bible.contest.constants.StringConstants.NO_BREAK_SPACE
import com.eladfinish.bible.contest.extensions.replaceRegex

/**
 * Like the Android actuals: the browser's JS regex engine handles look-behind natively and
 * fast, so there's no need for the hand-optimized Kotlin/Native workaround iOS uses.
 */

internal actual fun String.appendNbspAfterOtiotPasuk(): String =
    this.replaceRegex(
        regex = MyStringUtils.getRegexOfOtiotPasukPlainSpace(),
        replacement = "$1" + NO_BREAK_SPACE,
    )

internal actual fun findOtiotPasukMatches(text: CharSequence): List<OtiotPasukMatch> =
    getRegexOfOtiotPasuk().toRegex().findAll(text).map {
        // Kotlin/JS's MatchGroup doesn't expose `range` for individual groups; group 1 (the
        // letters) always starts at the overall match's start, per pattern B's structure.
        val letters = it.groups[1]!!
        OtiotPasukMatch(
            letters = letters.value,
            lettersStart = it.range.first,
            lettersEndExclusive = it.range.first + letters.value.length,
        )
    }.toList()

internal actual fun String.replaceOtiotPasuk(literalReplacement: String): String =
    this.replaceRegex(regex = getRegexOfOtiotPasuk(), replacement = literalReplacement)

internal actual fun String.parenthesizeOtiotPasuk(): String =
    this.replaceRegex(regex = getRegexOfOtiotPasuk(), replacement = "($1)$2")

internal actual fun String.removeOtPasukAfterNunMenuzeret(): String =
    this.replaceRegex(regex = getRegexOfOtiotPasukAfterNunMenuzeret(), replacement = "")

internal actual fun String.removeAliyotMarkersAfterNewline(): String =
    this.replaceRegex(regex = ALIYOT_AFTER_NEWLINE_REGEX, replacement = "")
